export const fakeImg = require("@/img/pic_ready.jpg");
export const fakeVideo = require("@/img/video_ready.png");
